const getLandingPageDomain = (language) => {
    switch (language) {
        case 'th':
            return 'https://www.sabanews-th.com';
        case 'in':
            return 'https://www.cricsabasportsin.com';
        case 'id':
            return 'https://www.thesabasportsindo.com';
        case 'vn':
            return 'https://www.sabavn.net/lich-thi-dau/bong-da';
        case 'zhcn':
        case 'ch':
        case 'cs':
            return 'https://www.thesabanewscn.com';
        default:
            return 'https://www.thesabamynews.com';
    }
}

export const goToSabaScore = (language) => {
    let landingPage = getLandingPageDomain(language);
    if (language === 'vn') {
        landingPage += `?v=${(new Date()).getTime()}`;
    }
    window.open(landingPage, 'sabaScore');
};

export const goToSabaScoreSingleMatch = (selectedSport, matchId, language) => {
    const landingPageDomain = getLandingPageDomain(language);
    const landingPage = `${landingPageDomain}/live-score/?sport=${selectedSport.toLowerCase()}&matchid=${matchId}`;
    window.open(landingPage, 'landingPage');
};
